export default "__VITE_ASSET__CQGx97NF__"